export default __webpack_public_path__ + "static/media/cp_geo_ci.6fb775f0.svg";